<template>
  <div>
    <h3>Callback</h3>
  </div>
</template>

<script>

export default {
  name: 'Oauth2Callback',
  mounted () {
    console.log('window.opener', window.opener)
    console.log('this.$route.query', JSON.stringify({ ...this.$route.query }))
    window.opener.postMessage({ ...this.$route.query })
  },
}
</script>
